import { AbstractBlock } from '../AbstractBlock';
import { utils } from '../other/BlocklyUtils';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
const Blockly = GlobalImport.getBlockly();

/**
 * @deprecated
 */
export class ColorValue extends AbstractBlock {
  /**
   * ブロックの外観定義
   * @param {ブロック} block
   */
  defineBlock(block: BlockType): void {
    // ブロックの属性をセット
    ShapeSettings.setValueShape(block);
    ColorSettings.setAttributeColor(block);

    // 属性値の入力フィールド
    const color = new Blockly.FieldColourSlider(utils.randomColour());
    block.appendDummyInput().appendField(color, 'COLOUR');
    block.setOutput('true', 'Colour');
  }

  codeGenerateCore(block: BlockType): string[] {
    const str = CodeSetting.getFieldValue(block, 'COLOUR');
    return [str];
  }
}
